
namespace q {

    export function layoutFillHeightValue(element: JQuery) {
        let h = 0;
        element.parent().children().not(element).each(function (i, e) {
            let q = $(e);
            if (q.is(':visible')) {
                h += q.outerHeight(true);
            }
        });
        h = element.parent().height() - h;

        if (element.css('box-sizing') !== 'border-box') {
            h = h - (element.outerHeight(true) - element.height());
        }
        return h;
    }

    export function layoutFillHeight(element: JQuery) {
        let h = layoutFillHeightValue(element);
        let n = Math.round(h) + 'px';
        if (element.css('height') != n) {
            element.css('height', n);
        }
    }



    export function initFullHeightTabs(gridDiv: JQuery) {
        $('body').addClass('full-height-page');
        gridDiv.addClass('responsive-height');

        let layout = function () {
            let inPageContent = gridDiv.parent().hasClass('page-content') ||
                gridDiv.parent().is('div.tab-pane');

            if (inPageContent) {
                gridDiv.css('height', '1px').css('overflow', 'hidden');
            }

            layoutFillHeight(gridDiv);

            if (inPageContent) {
                gridDiv.css('overflow', '');
            }

            gridDiv.triggerHandler('layout');
        };

        if ($('body').hasClass('has-layout-event')) {
            $('body').bind('layout', layout);
        }
        else if ((window as any).Metronic) {
            (window as any).Metronic.addResizeHandler(layout);
        }
        else {
            $(window).resize(layout);
        }

        layout();

        gridDiv.one('remove', () => {
            $(window).off('layout', layout);
            $('body').off('layout', layout);
        });

        // ugly, but to it is to make old pages work without having to add this
        //typeof Router != "undefined" && Router.resolve && Router.resolve();
    }



    export function initDetailEditor(dialog: any, editor: _Ext.GridEditorBase<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }
        if (options.height != undefined)
            editor.element.height(options.height);

        editor.slickGrid.resizeCanvas();

        editor.parentDialog = dialog;

        //dialog.onAfterSetDialogSize = () => {
        //    let $gridContainer = editor.element.find('.grid-container');

        //    if (options.height) {
        //        editor.slickGrid.setOptions({ autoHeight: false });
        //        $gridContainer.height(options.height);

        //    } else {
        //        let top = $gridContainer.position().top;
        //        let height = dialog.element.innerHeight() - top - 40;

        //        if (height > 200)
        //            $gridContainer.height(height);

        //    }

        //    if (options.width) {
        //        $gridContainer.width(options.width);

        //    }

        //    editor.slickGrid.resizeCanvas();

        //}

    }

    export function initTransDetailEditor(dialog: _Ext.TransDialog<any, any>, editor: _Ext.GridEditorBase<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }
        if (options.height != undefined)
            editor.element.height(options.height);

        editor.slickGrid.resizeCanvas();

        editor.parentTransDialog = dialog;


        //dialog.onAfterSetDialogSize = () => {
        //    let $gridContainer = editor.element.find('.grid-container');

        //    if (options.height) {
        //        editor.slickGrid.setOptions({ autoHeight: false });
        //        $gridContainer.height(options.height);

        //    } else {
        //        let top = $gridContainer.position().top;
        //        let height = dialog.element.innerHeight() - top - 40;

        //        if (height > 200)
        //            $gridContainer.height(height);

        //    }

        //    if (options.width) {
        //        $gridContainer.width(options.width);

        //    }

        //    editor.slickGrid.resizeCanvas();

        //}

    }

    export function initItemEditor(dialog: _Ext.TransDialog<any, any>, editor: _Ext.ItemGridEditor<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }
        if (options.height != undefined)
            editor.element.height(options.height);

        editor.slickGrid.resizeCanvas();

        editor.parentDialog = dialog;


    }

    export function initBOMEditor(dialog: _Ext.ItemDialog<any, any>, editor: _Ext.BOMGridEditor<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }
        if (options.height != undefined)
            editor.element.height(options.height);


        editor.slickGrid.resizeCanvas();

        editor.parentDialog = dialog;

        //dialog.onAfterSetDialogSize = () => {
        //    let $gridContainer = editor.element.find('.grid-container');

        //    if (options.height) {
        //        editor.slickGrid.setOptions({ autoHeight: false });
        //        $gridContainer.height(options.height);

        //    } else {
        //        let top = $gridContainer.position().top;
        //        let height = dialog.element.innerHeight() - top - 40;

        //        if (height > 200)
        //            $gridContainer.height(height);
        //    }

        //    if (options.width) {
        //        $gridContainer.width(options.width);
        //    }

        //    editor.slickGrid.resizeCanvas();
        //}
    }

    export function initMFGItemEditor(dialog: _Ext.MFGTransDialog<any, any>, editor: _Ext.MFGTransItemGridEditor<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }
        if (options.height != undefined)
            editor.element.height(options.height);

        editor.slickGrid.resizeCanvas();

        editor.parentDialog = dialog;


    }

    export function initMFGBOMEditor(dialog: _Ext.MFGTransItemDialog<any, any>, editor: _Ext.MFGTransBOMGridEditor<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }

        if (options.height != undefined)
            editor.element.height(options.height);

        editor.slickGrid.resizeCanvas();

        editor.parentDialog = dialog;
    }
    export function initMFGLaborEditor(dialog: _Ext.MFGTransItemDialog<any, any>, editor: _Ext.MFGLaborGridEditor<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }


        editor.parentDialog = dialog;

    }

    export function initLaborEditor(dialog: _Ext.ItemDialog<any, any>, editor: _Ext.LaborGridEditor<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }

        if (options.height != undefined)
            editor.element.height(options.height);

        editor.slickGrid.resizeCanvas();

        editor.parentDialog = dialog;

        //dialog.onAfterSetDialogSize = () => {
        //    let $gridContainer = editor.element.find('.grid-container');

        //    if (options.height) {
        //        editor.slickGrid.setOptions({ autoHeight: false });
        //        $gridContainer.height(options.height);

        //    } else {
        //        let top = $gridContainer.position().top;
        //        let height = dialog.element.innerHeight() - top - 40;

        //        if (height > 200)
        //            $gridContainer.height(height);
        //    }

        //    if (options.width) {
        //        $gridContainer.width(options.width);
        //    }

        //    editor.slickGrid.resizeCanvas();
        //}
    }

    export function initAdditionalChargesEditor(dialog: _Ext.ItemDialog<any, any>, editor: _Ext.GridEditorBase<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }

        if (options.height != undefined)
            editor.element.height(options.height);

        editor.slickGrid.resizeCanvas();

        editor.parentItemsDialog = dialog;
    }
    export function initMaterialIssueEditor(dialog: _Ext.MFGTransItemEditorDialog<any>, editor: _Ext.GridEditorBase<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }

        editor.parentMFGItemDialog = dialog;
    }
    export function initReceiptEditor(dialog: _Ext.ItemEditorDialog<any>, editor: _Ext.GridEditorBase<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }
        if (options.height != undefined)
            editor.element.height(options.height);

        editor.slickGrid.resizeCanvas();

        editor.parentItemDialog = dialog;
    }
    export function initDetailsEditor(dialog: _Ext.TransDialog<any, any>, editor: _Ext.DetailGridEditor<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }
        if (options.height != undefined)
            editor.element.height(options.height);

        editor.slickGrid.resizeCanvas();

        editor.parentDialog = dialog;
    }
    export function initSubDetailsEditor(dialog: _Ext.DetailEditorDialog<any>, editor: _Ext.SubDetailGridEditor<any>, options: ExtGridEditorOptions = {}): void {
        if (options.isReadOnly == true) {
            editor.set_readOnly(options.isReadOnly);
        }

        if (options.showCaption != true) {
            editor.element.siblings('.caption').hide();
        }
        if (options.hideToolbar == true) {
            editor.element.find('.grid-toolbar').hide()
        }
        if (options.height != undefined)
            editor.element.height(options.height);

        editor.slickGrid.resizeCanvas();

        editor.parentDialog = dialog;
    }
    export function setGridEditorHeight(editor: Serenity.Widget<any>, heightInPx: number) {
        editor.element.css('height', heightInPx + 'px');
        editor.element.find('.grid-container')
            .css('height', heightInPx + 'px')
            .height(heightInPx);
    }


    //thumb
    export function setImageEditorHeight(editor: Serenity.Widget<any>, heightInPx: number) {
        editor.element.css('height', heightInPx + 'px');
        editor.element.find('.editor')
            .css('height', heightInPx + 'px')
            .height(heightInPx);

        editor.element.children()
            .css('height', heightInPx + 'px')
            .css('width', heightInPx + 'px');

        editor.element.children().children()
            .css('height', heightInPx - 15 + 'px')
            .css('width', heightInPx - 15 + 'px');

        editor.element.children().children().children()
            .css('height', heightInPx - 25 + 'px')
            .css('width', heightInPx - 25 + 'px');
    }

    export function setTextRightAlign(editor: Serenity.Widget<any>) {
        editor.element.css('text-align', 'right');
    }

    export function hideEditorToolbar(editor: Serenity.Widget<any>) {
        editor.element.find('.grid-toolbar').attr("style", "display:none;");

    }
    export function showEditorToolbar(editor: Serenity.Widget<any>) {
        editor.element.find('.grid-toolbar').attr("style", "display:block;");

    }
    //.s-ImageUploadEditor ul

    export function hideImageToolbar(editor: Serenity.Widget<any>) {
        editor.element.find('.s-Toolbar').attr("style", "display:none;");
    }
    export function SetCategoryFullWidth(editor: Serenity.Widget<any>) {
        editor.element.closest('.category').addClass("col-md-12 col-sm-12");
    }

    export function SetCategoryTenColumn(editor: Serenity.Widget<any>) {
        editor.element.closest('.category').addClass("col-md-10 col-sm-10");
    }
    export function SetCategoryNineColumn(editor: Serenity.Widget<any>) {
        editor.element.closest('.category').addClass("col-md-9 col-sm-9");
    }

    export function SetCategoryEightColumn(editor: Serenity.Widget<any>) {
        editor.element.closest('.category').addClass("col-md-8 col-sm-8");
    }

    export function SetCategorySixColumn(editor: Serenity.Widget<any>) {
        editor.element.closest('.category').addClass("col-sm-6 col-md-6");
    }

    export function SetSix12Column(editor: Serenity.Widget<any>) {
        editor.element.closest('.category').addClass("col-sm-12 col-md-6 col-md-6-ipad");
    }

    export function SetFive12Column(editor: Serenity.Widget<any>) {
        editor.element.closest('.category').addClass("col-sm-12 col-md-5 col-md-6-ipad");
    }

    export function SetTwo12Column(editor: Serenity.Widget<any>) {
        editor.element.closest('.category').addClass("col-sm-12 col-md-2 col-md-6-ipad");
    }

    export function SetCategoryFourColumn(editor: Serenity.Widget<any>) {
        editor.element.closest('.category').addClass("col-sm-6 col-md-4 col-md-4-ipad");
    }

    export function SetCategoryThreeColumn(editor: Serenity.Widget<any>) {
        editor.element.closest('.category').addClass("col-md-3 col-sm-3");

    }

    export function SetCategoryTwoColumn(editor: Serenity.Widget<any>) {
        editor.element.closest('.category').addClass("col-sm-6 col-md-2 col-md-2-ipad");

    }

    export function closeTabInsideCategory(editor: Serenity.Widget<any>) {
        editor.element.append('</div>');

    }

    export function HideCategoryLable(editor: JQuery) {
        editor.find('.category-links').hide();

        let $FirstCategory = editor.find('.first-category > .category-title');
        $FirstCategory.hide();

        let $Category = editor.find('.category-title');
        $Category.hide();

    }
    export function HideDialogToolbar(editor: JQuery) {
        editor.find('.s-DialogToolbar').hide();

        let $FirstCategory = editor.find('.s-Toolbar');
        $FirstCategory.hide();

    }
    export function HideOnlyDialogToolbar(editor: JQuery) {
        editor.find('.s-DialogToolbar').hide();

    }
    export function ShowCategoryLable(editor: JQuery) {
        let $FirstCategory = editor.find('.first-category > .category-title');
        $FirstCategory.show();

        let $Category = editor.find('.category-title');
        $Category.show();

    }
    export function hideEditorCategoryLabel(editor: JQuery) {
        //editor.closest('.category').addClass("col-sm-6 col-md-4 col-md-4-ipad");

        //editor.find('.category-links').hide();

        //let $FirstCategory = editor.find('.first-category > .category-title');
        //$FirstCategory.hide();
        let $Category = editor.closest('.category').find('.category-title');
        $Category.hide();
    }
    export function addNotificationIcon(editor: Serenity.Widget<any>, isSuccess: boolean): void {

        let isAddOnInitialized = editor.element.data('isAddOnInitialized');

        if (isAddOnInitialized != true) {
            editor.element.after('<span class="text text-danger" style="padding:3px"><i class="fa fa-times"></i></span>');
            editor.element.data('isAddOnInitialized', true);
        }

        if (isSuccess == true) {
            editor.element.switchClass('bg-danger', 'bg-success')
                .siblings('.text').switchClass('text-danger', 'text-success')
                .children().switchClass('fa-times', 'fa-check');
        } else {
            editor.element.switchClass('bg-success', 'bg-danger')
                .siblings('.text').switchClass('text-success', 'text-danger')
                .children().switchClass('fa-check', 'fa-times');

        }
    }

    export function addPopoverIcon(editor: Serenity.Widget<any>, isSuccess: boolean, popoverOptions: any): void { // popoverOptions: Bootstrap.PopoverOptions
        addNotificationIcon(editor, isSuccess);

        //(editor.element as any).popover('destroy');
        (editor.element.siblings('.text') as any).popover('destroy');

        setTimeout(h => {
            //(editor.element as any).popover(popoverOptions);
            (editor.element.siblings('.text') as any)
                .popover(popoverOptions)
                .on("show.bs.popover", function () { $(this).data("bs.popover").tip().css("width", "600px"); });;
        }, 100)

    }

    export function setEditorLabel(editor: Serenity.Widget<any>, value: string) {

        editor.element.siblings('label').text(value);
    }

    export function hideEditorLabel(editor: Serenity.Widget<any>) {

        editor.element.siblings('label').hide();
    }

    export function hideCaption(editor: Serenity.Widget<any>) {

        editor.element.siblings('label').hide();
    }


    export function AmountField(editor: Serenity.Widget<any>) {
        editor.element.closest('.field').attr("style", "display:block;");
        //editor.element.siblings('label').css('padding-bottom', '0.5em');  // font-weight
        //editor.element.siblings('label').css('font-weight', 'bold');  // font-weight
    }

    export function setEditorCategoryLabel(editor: Serenity.Widget<any>, value: string) {
        let categoryAnchor = editor.element.closest('.category').find('.category-anchor');
        categoryAnchor.text(value);

        let categoryAnchorName = categoryAnchor.attr('name');
        categoryAnchor.closest('.s-PropertyGrid').find(`a[href='#${categoryAnchorName}']`).text(value);
    }

    export function hideEditorCategory(editor: Serenity.Widget<any>, value: boolean = true) {
        if (value == true)
            editor.element.closest('.category').hide();
        else
            editor.element.closest('.category').show();

        let categoryAnchor = editor.element.closest('.category').find('.category-anchor');

        let categoryAnchorName = categoryAnchor.attr('name');
        if (value == true)
            categoryAnchor.closest('.s-PropertyGrid').find(`a[href='#${categoryAnchorName}']`).hide();
        else
            categoryAnchor.closest('.s-PropertyGrid').find(`a[href='#${categoryAnchorName}']`).show();
    }

    export function hideCategories(containerElement: JQuery, value: boolean = true) {
        if (value == true)
            containerElement.find('.category').hide();
        else
            containerElement.find('.category').show();

        let categoryAnchor = containerElement.find('.category').find('.category-anchor');

        let categoryAnchorName = categoryAnchor.attr('name');
        if (value == true)
            categoryAnchor.closest('.s-PropertyGrid').find(`a[href='#${categoryAnchorName}']`).hide();
        else
            categoryAnchor.closest('.s-PropertyGrid').find(`a[href='#${categoryAnchorName}']`).show();
    }

    export function hideCategorylinks(containerElement: JQuery, value: boolean = true) {
        if (value == true)
            containerElement.find('.category-links').hide();
        else
            containerElement.find('.category-links').show();
    }

    export function hideFields(containerElement: JQuery, value: boolean = true) {
        if (value == true)
            containerElement.find('.field').hide();
        else
            containerElement.find('.field').show();
    }

    export function hideFieldsAndCategories(containerElement: JQuery, value: boolean = true) {
        hideFields(containerElement);
        hideCategories(containerElement);
    }

    // Hide Field on form
    export function hideField(editor: Serenity.Widget<any>, value: boolean = true) {
        //<summary> Hide Field on Form  < /summary>
        if (editor) {
            if (value == true) {
                editor.element.closest('.field').hide();
                Serenity.EditorUtils.setRequired(editor, false);
            }
            else
                editor.element.closest('.field').show();
        }
    }

    export function showField(editor: Serenity.Widget<any>, value: boolean = true) {
        if (editor) {
            if (value == true)
                editor.element.closest('.field').show();
            else
                editor.element.closest('.field').hide();
        }
    }

    export function showAndEnableField(editor: Serenity.Widget<any>) {
        if (editor != undefined) {
            q.showField(editor);
            Serenity.EditorUtils.setReadOnly(editor, false);
            Serenity.EditorUtils.setRequired(editor, false);
        }

    }

    export function showAndSetRequiredField(editor: Serenity.Widget<any>) {
        if (editor != undefined) {
            q.showField(editor);
            Serenity.EditorUtils.setRequired(editor, true);
            Serenity.EditorUtils.setReadOnly(editor, false);
        }

    }

    export function showAndDisableField(editor: Serenity.Widget<any>) {
        if (editor != undefined) {
            q.showField(editor);
            Serenity.EditorUtils.setReadOnly(editor, true);
            Serenity.EditorUtils.setRequired(editor, false);
        }

    }

    export function showFieldAndCategory(editor: Serenity.Widget<any>, value: boolean = true) {
        if (editor != undefined) {
            showField(editor, value);
            if (value == true)
                hideEditorCategory(editor, false);
            else
                hideEditorCategory(editor, true);
        }
    }

    export function hideEditorTab(editor: Serenity.Widget<any>, value: boolean = true) {
        if (value) {
            let tabId = editor.element.closest('.tab-pane').hide().attr('id');
            let tabAnchor = editor.element.closest('.s-PropertyGrid').find(`a[href='#${tabId}']`);
            tabAnchor.closest('li').hide();
        } else {
            let tabId = editor.element.closest('.tab-pane').show().attr('id');
            let tabAnchor = editor.element.closest('.s-PropertyGrid').find(`a[href='#${tabId}']`);
            tabAnchor.closest('li').show();
        }
    }

    export function disableEditorTab(editor: Serenity.Widget<any>, value: boolean = true) {
        let tabId = editor.element.closest('.tab-pane').attr('id');

        let tabAnchor = editor.element.closest('.s-PropertyGrid').find(`a[href='#${tabId}']`);
        let tabLi = tabAnchor.closest('li');

        if (value == true) {
            tabAnchor.hide();
            tabLi.closest('li').addClass('disabled').prepend(`<a class="disabled">${tabAnchor.text()}</label>`);
        } else {
            tabAnchor.show();
            tabLi.closest('li').removeClass('disabled').find('.disabled').remove();

        }

    }

    export function readOnlyEditorTab(editor: Serenity.Widget<any>, value: boolean = true) {
        let $editors = editor.element.closest('.tab-pane').find('.editor');

        Serenity.EditorUtils.setReadonly($editors, value);
    }

    export function readOnlyEditorCategory(editor: Serenity.Widget<any>, value: boolean = true) {
        let $editors = editor.element.closest('.category').find('.editor');

        Serenity.EditorUtils.setReadonly($editors, value);
    }
    export function readonlyEditorCategory($editor: JQuery, value: boolean = true) {
        let $editors = $editor.closest('.category').find('.editor');
        Serenity.EditorUtils.setReadonly($editors, value);
    }

    export function readOnlyEditorPropertyGrid(editor: Serenity.Widget<any>, value: boolean = true) {
        let $editors = editor.element.closest('.s-PropertyGrid').find('.editor');
        Serenity.EditorUtils.setReadonly($editors, value);
    }
    export function readonlyEditorPropertyGrid($editor: JQuery, value: boolean = true) {
        let $editors = $editor.closest('.s-PropertyGrid').find('.editor');
        Serenity.EditorUtils.setReadonly($editors, value);
    }

    export function readOnlyEditor(editor: Serenity.Widget<any>, value: boolean = true) {
        Serenity.EditorUtils.setReadOnly(editor, value);
    }

    export function readonlyEditor($editor: JQuery, value: boolean = true) {
        Serenity.EditorUtils.setReadonly($editor, value);
    }

    export function moveEditorFromTab(editor: Serenity.Widget<any>, toElement: JQuery, isPrepend = false) {
        let fieldDiv = editor.element.closest('.field');

        if (isPrepend == true)
            fieldDiv.prependTo(toElement);
        else
            fieldDiv.appendTo(toElement);
    }

    export function moveEditorCategoryFromTab(editor: Serenity.Widget<any>, toElement: JQuery, isPrepend = false) {
        let fieldDiv = editor.element.closest('.field');
        let categoryDiv = editor.element.closest('.category');

        if (isPrepend == true)
            categoryDiv.prependTo(toElement);
        else
            categoryDiv.appendTo(toElement);

        //hide category navigation link
        let categoryAnchor = categoryDiv.find('.category-anchor');
        let categoryAnchorName = categoryAnchor.attr('name');
        categoryAnchor.closest('.s-PropertyGrid').find(`a[href='#${categoryAnchorName}']`).hide();

    }

    export function selectEditorTab(editor: Serenity.Widget<any>) {
        let tabId = editor.element.closest('.tab-pane').attr('id');

        let tabAnchor = editor.element.closest('.s-PropertyGrid').find(`a[href='#${tabId}']`);

        (tabAnchor as any).tab('show');
    }

    // for select2 lookup editor
    export function getSelectedRow<TRow>(e: JQueryEventObject) {
        let selectedItem: Serenity.Select2Item = (e as any).added;
        let selectedRow: TRow = selectedItem.source;

        return selectedRow;
    }

    export const Filter = (arr: Object[], filters: Object) => {
        const filterKeys = Object.keys(filters);
        return arr.filter(eachObj => {
            return filterKeys.every(eachKey => {
                if (!filters[eachKey].length) {
                    return true; // passing an empty filter means that filter is ignored.
                }
                return filters[eachKey].includes(eachObj[eachKey]);
            });
        });
    }

}
